module.exports = __webpack_public_path__ + "static/media/SportLeague.2c60e45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/SportLeague.png
// module id = 3825
// module chunks = 1